export default "__VITE_ASSET__D9R_xI7Y__"